import React, { useState, useEffect } from 'react'
import axios from "axios";

import Spinner from "./Spinner/Spinner"
import QuotesList from "./QuotesList";
import SingleQuote from "./SingleQuote";


const Search = () => {

  const [query, setQuery] = useState("");

  const [quotes, setQuotes] = useState([]);

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [first, setFirst] = useState([]);
  const [firstKeywords, setFirstKeywords] = useState([]);

  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [perPage, setPerPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const fetchQuotes = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STOIC_SEARCH}/${query}?page=${pageNumber}&limit=18`
      );
      setQuotes(response.data.results);
      if (response.data.results.length === 1) {
        setFirst(response.data.results[0])
        setFirstKeywords(response.data.results[0].keywords)
      }
      setTotal(response.data.total_results);
      setTotalPages(response.data.total_pages);
      setPerPage(response.data.per_page);
      setCurrentPage(response.data.page);
      setLoading(false);    

    } catch (error) {
      setError(error);
    }
  };

  const handleChange = (e) => {
    setQuery(e.target.value);
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setQuery(query)
  };


  useEffect(() => {
    setFirst([])
    setQuotes([])
    setError(false)
    if (query.length === 1 && !isNaN(query)) {
      fetchQuotes(1);
    } else if (query.length > 1) {
      fetchQuotes(1);
    }
  }, [query]);

  return (
    <div className="w-full">
      <div className="flex flex-col">
        <div className="md:mx-24 lg:mx-40 xl:mx-64">
          <form onSubmit={handleSubmit} className="flex justify-end w-full text-gray-800" >
            <input
              type="text"
              placeholder="Search quotes, authors or keywords"
              value={query}
              onChange={handleChange}
              onSubmit={handleSubmit}
              className="w-full shadow-xl p-3 mb-10 text-lg border border-solid rounded-md border-gray-400"
            />
          </form>
        </div>
      <div>
      </div>

      {loading && !error ? 
        (<div className="flex justify-center"><Spinner/></div>) 
        : 
        ((quotes.length === 0) ? 
        (query ? (<div className="mb-6 flex justify-center text-lg text-gray-600 font-semibold italic">No results for '{query}'</div>) : (null)) 
        : 
        (quotes.length === 1 ? 
          (<SingleQuote singleQuote={first} singleQuoteKeywords={firstKeywords} />) 
          : 
          (<QuotesList
            quotes={quotes}
            total={total}
            totalPages={totalPages}
            perPage={perPage}
            currentPage={currentPage}
            fetchQuotes={fetchQuotes}
            loading={loading}
            query={query}
            allquotes={true}
            />
        )))
}
      </div> 
    </div>
  );
};

export default Search;
